export const REMIX_AI_WARNING_TEXT = "AI can make mistakes";

// Matches RemixUploader "AI BETA" tags (remix upload modal dropdown).
export const REMIX_AI_BETA_BADGE_CLASS =
  "inline-flex items-center relative ml-2 top-[-3px] bg-blue-600 py-0.5 px-2 rounded text-sm text-white font-medium align-middle";

export const REMIX_AI_WARNING_CLASS =
  "mt-1 mb-0 pl-4 text-sm text-slate-400 font-normal";

export function remixAiBetaBadgeHtml() {
  return `<span class="${REMIX_AI_BETA_BADGE_CLASS}">Beta</span>`;
}
